export default __webpack_public_path__ + "static/media/card__image__bg--two.c667a618.jpg";